import axios, { AxiosRequestConfig } from 'axios';
import { withAuth } from '../interceptors/withAuth';
import { createRequester } from './requester';

export const apiClient = (baseURL: string, axiosConfig?: AxiosRequestConfig) =>
  axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
    validateStatus: (status) => {
      return status >= 200 && status < 300;
    },

    ...axiosConfig,
  });

export const createApiClient = (baseURL: string, axiosConfig?: AxiosRequestConfig) =>
  createRequester(apiClient(baseURL, axiosConfig));

// Bearer-attaching variant for browser-side fetching; server-only callers (e.g. login) use `createApiClient`.
export const createAuthedApiClient = (
  baseURL: string,
  deps: Parameters<typeof withAuth>[1],
  axiosConfig?: AxiosRequestConfig,
) => createRequester(withAuth(apiClient(baseURL, axiosConfig), deps));
